export class PetVisitModel {
    pet_no: number
    discharge_time: any
    discharge_time_extra: any
    assigned_doctor: string
    supervising_doctor: string
    clinic_dept: string
    invoice_limit: string
    assigned_nurse1: string
    assigned_nurse2: string

    constructor(
        pet_no: number,
        discharge_time: any,
        discharge_time_extra: any,
        assigned_doctor: string,
        supervising_doctor: string,
        clinic_dept: string,
        invoice_limit: string,
        assigned_nurse1: string,
        assigned_nurse2: string,
    ) {
        this.pet_no = pet_no
        this.discharge_time = discharge_time
        this.discharge_time_extra = discharge_time_extra
        this.assigned_doctor = assigned_doctor
        this.supervising_doctor = supervising_doctor
        this.clinic_dept = clinic_dept
        this.invoice_limit = invoice_limit
        this.assigned_nurse1 = assigned_nurse1
        this.assigned_nurse2 = assigned_nurse2
    }
}